export default __webpack_public_path__ + "static/media/013-cctv.1b8820db.png";